
import DashboardLayout from '../pages/Dashboard/Layout/DashboardLayout'
// Extranet
import SinisterPackages from '../pages/extranet/SinisterPackages'
import EditSinisterPackages from '../pages/extranet/EditSinisterPackages'
import PackageTracking from '../pages/extranet/PackageTracking'
import SinisterView from '../pages/extranet/SinisterView'
import CustomerPackage from '../pages/extranet/CustomerPackage'


const extranet = {
  path: '/',
  component: DashboardLayout,
  name: 'Extranet',
  title: 'Extranet',
  icon: 'table_chart',
  excludedGroups: [ 'Extranet' ],
  excludedRoles: [ 'IDEAL' ],
  children: [
    {
      path: '/extranet/listado_para_extranet',
      name: 'Listado para extranet',
      title: 'Armado de paquetes',
      // roles: ['ADM', 'GEFI', 'GECA'],
      meta: {
        ifUserCan: {
          add: 'extranet/sinisterspackage'
        }
      },
      component: SinisterPackages,
    },
    {
      path: '/extranet/edicion_para_extranet/:id',
      name: 'Edicion para extranet',
      // roles: ['ADM', 'GEFI', 'GECA'],
      component: EditSinisterPackages,
      meta: {
        ifUserCan: {
          change: 'extranet/sinisterspackage'
        }
      },
      props: route => ({ id: route.params.id }),
    },
    {
      path: '/extranet/seguimiento_de_paquetes',
      name: 'Seguimiento de paquetes',
      title: 'Seguimiento de paquetes',
      // roles: ['ADM', 'GEFI', 'GECA'],
      meta: {
        ifUserCan: {
          change: 'extranet/sinisterspackage'
        }
      },
      component: PackageTracking,
    },
    {
      path: '/extranet/aprobación_de_siniestros',
      name: 'Aprobacion de siniestros',
      title: 'Aprobacion de siniestros',
      // roles: ['ADM', 'GEFI', 'GECA', 'EXCLI'],
      meta: {
        ifUserCan: {
          // :TODO: Set correct extranet permission
          change: 'extranet/sinisterspackage'
        }
      },
      component: CustomerPackage,
    },
    {
      path: '/extranet/siniestro/:id',
      name: 'Vista de siniestro',
      // roles: ['ADM', 'GEFI', 'GECA', 'EXCLI'],
      component: SinisterView,
      meta: {
        ifUserCan: {
          // :TODO: Set correct extranet permission
          view: 'extranet/sinistersinpackage'
        }
      },
    },
  ],
}

export default extranet



// WEBPACK FOOTER //
// ./src/router/extranetRoutes.js